import React, {Component, Fragment} from 'react';
import {Card, Form, FormFeedback, FormGroup, Input, Label} from 'reactstrap';
import withValidator from '../../models/form/withValidator';
import LoadingButton from '../../../shared/ui/LoadingButton';
import './RatingMultiFormCard.scss'
import Checkbox from "../../../shared/forms/Checkbox";

const validatorConfig = {
  cssClasses: {
    fieldInvalid: 'is-invalid',
    fieldValid: 'is-valid',
  },
  fields: {
    ratingPrompt: {
      rules: [
        {
          feedback: 'Prompt is required',
          test(value) {
            return !!value;
          },
        },
      ],
    },
    acceptable: {
      rules: [
        {
          feedback: 'Acceptable prompt is required',
          test(value) {
            return !!value;
          },
        },
      ],
    },
    unAcceptable: {
      rules: [
      ],
    },
    useNoNr: {
      rules: []
    },
    useNo: {
      rules: []
    },
    notResponsivePrompt: {
      rules: [],
    },

    notObservedPrompt: {
      rules: [],
    },

    requireAckResponse: {
      rules: [],
    },
    reqiureUnacceptableComment: {
      rules: [],
    },
    timeSpendFieldPrompt: {
      rules: [],
    },
  },
};

class AcceptableUnacceptableFormCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cssValidationClasses: {
        ratingPrompt: '' ,
        acceptable: '' ,
        unAcceptable: '',
        notResponsivePrompt: '',
        notObservedPrompt: ''
      },
      dropdownOpen: false,
      errorFeedback: {},
      isFormDisabled: true,
      ratingPrompt: !this.props.initialValues ? '' : this.props.initialValues.ratingPrompt,
      acceptable: !this.props.initialValues ? 'Acceptable' : this.props.initialValues.acceptable,
      unAcceptable: !this.props.initialValues ? 'Unacceptable' : this.props.initialValues.unAcceptable,
      useNoNr: !this.props.initialValues ? false : this.props.initialValues.useNoNr,
      useNo: !this.props.initialValues ? false : this.props.initialValues.useNo,
      notResponsivePrompt: !this.props.initialValues ? '' : this.props.initialValues.notResponsivePrompt,
      notObservedPrompt: !this.props.initialValues ? '' : this.props.initialValues.notObservedPrompt,
      requireAckResponse: !this.props.initialValues ? false : !!this.props.initialValues.requireAckResponse,
      reqiureUnacceptableComment: !this.props.initialValues ? false : !!this.props.initialValues.reqiureUnacceptableComment,
      hasTimeSpendField: !this.props.initialValues ? false : !!this.props.initialValues.hasTimeSpendField,
      timeSpendFieldPrompt: (!this.props.initialValues ? sessionStorage.getItem('timeSpendFieldPrompt') : (this.props.initialValues.timeSpendFieldPrompt || sessionStorage.getItem('timeSpendFieldPrompt'))),
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    if (this.props.initialValues) {
      this.props.initialize({
        ratingPrompt: this.state.ratingPrompt,
        acceptable: this.state.acceptable,
        unAcceptable: this.state.unAcceptable,
        useNoNr: this.state.useNoNr,
        useNo: this.state.useNo,
        notResponsivePrompt: this.state.notResponsivePrompt,
        notObservedPrompt: this.state.notObservedPrompt,
        requireAckResponse: this.state.requireAckResponse,
        reqiureUnacceptableComment: this.state.reqiureUnacceptableComment,
        timeSpendFieldPrompt: this.state.timeSpendFieldPrompt,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      cssValidationClasses: nextProps.cssValidationClasses,
      errorFeedback: nextProps.errorFeedback,
      isFormDisabled: this.getIsFormInvalid(
        nextProps.hasErrors,
        nextProps.hasUntouched,
      ),
    });
  }

  // ----------------------
  // Methods
  // ----------------------

  getIsFormInvalid(hasErrors, hasUntouched) {
    return hasErrors || hasUntouched;
  }

  handleBlur(event) {
    const { name, value } = event.target;
    this.props.touch(name);
    this.props.validateField(name, value, true);
  }

  handleInput(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () =>
      this.props.validateField(name, value, true));

    if (name === 'timeSpendFieldPrompt') {
      sessionStorage.setItem('timeSpendFieldPrompt', value)
    }
  }

  updateNoNr(event) {
    this.setState({useNoNr: event.target.checked});
  }

  updateNo(event) {
    this.setState({useNo: event.target.checked});
  }

  handleSubmit() {
    const properties = {
      ratingPrompt: this.state.ratingPrompt,
      unAcceptable: this.state.unAcceptable,
      acceptable: this.state.acceptable,
      useNoNr: this.state.useNoNr,
      useNo: this.state.useNo,
      notObservedPrompt: this.state.notObservedPrompt,
      notResponsivePrompt: this.state.notResponsivePrompt,
      requireAckResponse: this.state.requireAckResponse,
      reqiureUnacceptableComment: this.state.reqiureUnacceptableComment,
      hasTimeSpendField: this.state.hasTimeSpendField,
      timeSpendFieldPrompt: this.state.timeSpendFieldPrompt,
    };
    this.props.onSave(properties);
  }

  updateRequireAckCommentField(val) {
    this.setState({
      requireAckResponse: val
    })
  }

  updateRequireUnacceptableCommentField(val) {
    this.setState({
      reqiureUnacceptableComment: val
    })
  }

  // ----------------------
  // State setters
  // ----------------------

  toggle() {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  }

  updateTimeSpendField(val) {
    this.setState({
      hasTimeSpendField: val
    })
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        <Card className="mb-3 rating-multi-form-card">
          <Form
            className="m-3"
            noValidate
            onSubmit={event => this.handleSubmit(event)}
          >
            <FormGroup>
              <Label for="ratingPrompt">Rating prompt *</Label>
              <Input
                className={this.state.cssValidationClasses.ratingPrompt}
                id="ratingPrompt"
                name="ratingPrompt"
                onBlur={event => this.handleBlur(event)}
                onChange={event => this.handleInput(event)}
                placeholder="Header"
                type="textarea"
                rows={2}
                value={this.state.ratingPrompt}
              />
              <FormFeedback>{this.state.errorFeedback.ratingPrompt}</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="acceptable">Acceptable prompt *</Label>
              <Input
                className={this.state.cssValidationClasses.acceptable}
                id="acceptable"
                name="acceptable"
                onBlur={event => this.handleBlur(event)}
                onChange={event => this.handleInput(event)}
                placeholder="Acceptable"
                value={this.state.acceptable}
              />
              <FormFeedback>{this.state.errorFeedback.acceptable}</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="unAcceptable">Unacceptable prompt *</Label>
              <Input
                className={this.state.cssValidationClasses.unAcceptable}
                id="unAcceptable"
                name="unAcceptable"
                onBlur={event => this.handleBlur(event)}
                onChange={event => this.handleInput(event)}
                placeholder="Unacceptable"
                value={this.state.unAcceptable}
              />
              <FormFeedback>{this.state.errorFeedback.unAcceptable}</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Checkbox checked={this.state.useNoNr} label="Use NO/NR fields?"
                        onChange={(checked) => this.updateNoNr(checked)}/>
            </FormGroup>


            {this.state.useNoNr && (
              <Fragment>
                <FormGroup>
                  <Label for="notObservedPrompt">Not observed prompt *</Label>
                  <Input
                    className={this.state.cssValidationClasses.notObservedPrompt}
                    id="notObservedPrompt"
                    name="notObservedPrompt"
                    onBlur={event => this.handleBlur(event)}
                    onChange={event => this.handleInput(event)}
                    placeholder="Header"
                    value={this.state.notObservedPrompt}
                  />
                  <FormFeedback>{this.state.errorFeedback.notObservedPrompt}</FormFeedback>
                </FormGroup>
                <FormGroup>
                  <Label for="notResponsivePrompt">Not responsive prompt *</Label>
                  <Input
                    className={this.state.cssValidationClasses.notResponsivePrompt}
                    id="notResponsivePrompt"
                    name="notResponsivePrompt"
                    onBlur={event => this.handleBlur(event)}
                    onChange={event => this.handleInput(event)}
                    placeholder="Header"
                    value={this.state.notResponsivePrompt}
                  />
                  <FormFeedback>{this.state.errorFeedback.notResponsivePrompt}</FormFeedback>
                </FormGroup>
              </Fragment>
            )}

            <FormGroup>
              <Checkbox checked={this.state.useNo} label="Use NO field?"
                        onChange={(checked) => this.updateNo(checked)}/>
            </FormGroup>

            {this.state.useNo && (
              <Fragment>
                <FormGroup>
                  <Label for="notObservedPrompt">Not observed prompt *</Label>
                  <Input
                    className={this.state.cssValidationClasses.notObservedPrompt}
                    id="notObservedPrompt"
                    name="notObservedPrompt"
                    onBlur={event => this.handleBlur(event)}
                    onChange={event => this.handleInput(event)}
                    placeholder="Header"
                    value={this.state.notObservedPrompt}
                  />
                  <FormFeedback>{this.state.errorFeedback.notObservedPrompt}</FormFeedback>
                </FormGroup>
              </Fragment>
            )}

            <div className="mb-4">
              <Checkbox
                label="Require comment on fail"
                checked={this.state.reqiureUnacceptableComment}
                onChange={e => this.updateRequireUnacceptableCommentField(e.target.checked)}
              />
            </div>

            <div className="mb-4">
              <Checkbox
                label="Require acknowledgement comment"
                checked={this.state.requireAckResponse}
                onChange={e => this.updateRequireAckCommentField(e.target.checked)}
              />
            </div>

            <div className="mb-4">
              <Checkbox
                label="Has time spend field"
                checked={this.state.hasTimeSpendField}
                onChange={e => this.updateTimeSpendField(e.target.checked)}
              />
            </div>
            {this.state.hasTimeSpendField && (
              <div className="mb-4">
                <FormGroup>
                  <Label for="timeSpendFieldPrompt">Time spend field prompt</Label>
                  <Input
                    id="timeSpendFieldPrompt"
                    name="timeSpendFieldPrompt"
                    onBlur={event => this.handleBlur(event)}
                    onChange={event => this.handleInput(event)}
                    placeholder="Time spend field prompt"
                    value={this.state.timeSpendFieldPrompt}
                  />
                </FormGroup>
              </div>
            )}

            <div>
              <LoadingButton
                primary
                text="Save"
                isLoading={this.props.isLoading}
                disabled={this.state.isFormDisabled}
                onClick={event => this.handleSubmit(event)}
              />
            </div>
          </Form>
        </Card>
      </Fragment>
    );
  }
}

export default withValidator(AcceptableUnacceptableFormCard, validatorConfig);
